import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';

// Components
import Select from './Select';
import Emails from './Emails';
import UploadExcel from './UploadExcel';
import EditEmails from './EditEmails';
import Post from './Post';

const Box = props => {
	const [ state, dispatch ] = useContext( GlobalContext );
	const { step, notify, isLoading, isConfirmedCloseVisible, selectedDistributionMethod } = state;

	function renderSwitch() {
		switch ( step ) {
			case 'emails':
				return <Emails { ...props } />;
			case 'uploadExcel':
				return <UploadExcel { ...props } />;
			case 'editEmails':
				return <EditEmails { ...props } />;
			case 'post':
				return <Post { ...props } />;
			default:
				return <Select { ...props } />;
		}
	}

	return (
		<div className="digital-code-box">
			{ null !== notify ? <div className={ `info-${ notify.class }` }>
				<span>{ notify.msg }</span>
				{ isConfirmedCloseVisible
					? <a onClick={ () => { // eslint-disable-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
						dispatch( {
							type: 'SET_CONFIRMED_CLOSE_VISIBILITY',
							payload: false,
						} );
						dispatch( {
							type: 'SET_NOTIFY',
							payload: null,
						} );
						dispatch( {
							type: 'SET_OVERLAY_VISIBILITY',
							payload: false,
						} );

						if ( selectedDistributionMethod ) {
							dispatch( {
								type: 'SET_STEP',
								payload: 'savedData',
							} );
						}
					}
					}> Stäng</a>
					: null
				}
			</div> : null }
			{ isLoading ? <div className="loader"></div> : null }
			{ renderSwitch() }
		</div>
	);
};

export default Box;
